import {ApolloClient} from '@apollo/client';

import {Recurso} from 'lib.common/dist/CleanArch';
import {ErrExterno} from 'lib.common/dist/errorHandler';
import {gqlErrorsMapperRecurso} from 'lib.front/dist/common/funErrorMappers';
import {GestionarAppDtSource} from '../../bussines/dataSources/GestionarAppDtSource';
import {
   DeleteDatabasesInParams,
   DeleteDatabasesOutParams
} from '../../utils/params/DeleteDatabasesParams';
import {deleteDbInstancesGql} from '../../utils/gql/gestionarAppsDbsGql';

export class GestionarAppDtSourceImplGql implements GestionarAppDtSource {
   private apolloClient: ApolloClient<object>;

   constructor(ApolloClient: ApolloClient<object>) {
      this.apolloClient = ApolloClient;
   }
   async deleteDbs(input: DeleteDatabasesInParams): Promise<Recurso<DeleteDatabasesOutParams>> {
      try {
         const variables = {
            app: input.appId,
            databasesInfo: input.list.map(curr => {
               return {
                  idDatabase: curr.dbName,
                  idInstancia: curr.idInstancia,
                  estado: curr.estado
               };
            })
         };

         const response = await this.apolloClient.mutate({
            mutation: deleteDbInstancesGql,
            variables
         });
         const errorRecurso = gqlErrorsMapperRecurso<DeleteDatabasesOutParams>(response.errors);
         return errorRecurso ?? Recurso.fromData(response.data.deleteDatabasesApp);
      } catch (error) {
         return Recurso.fromError(new ErrExterno(error as Error));
      }
   }
}
